import type { EntityVersionAnalyticsQuerySnapshot } from "./types";

import type { Filter, FilterValue } from "@/components/StructuredSearch/config/types";
import type { StructuredSearchStore } from "@/components/StructuredSearch/stores/structured-search/structured-search-store";

const cloneFilterValue = (value: FilterValue): FilterValue => {
  if (Array.isArray(value)) {
    return value.map(item =>
      typeof item === "object" && item !== null ? { ...item } : item,
    ) as FilterValue;
  }

  if (typeof value === "object" && value !== null) {
    return { ...value };
  }

  return value;
};

export const cloneFilter = (filter: Filter): Filter => ({
  ...filter,
  value: cloneFilterValue(filter.value),
  multiValueDisplay: filter.multiValueDisplay ? [...filter.multiValueDisplay] : undefined,
});

export const snapshotStructuredSearchQuery = (
  store: StructuredSearchStore,
): EntityVersionAnalyticsQuerySnapshot => ({
  lockedFilters: store.lockedFilters.map(cloneFilter),
  editableFilters: store.filters
    .filter(filter => !store.isFilterLocked(filter.id))
    .map(cloneFilter),
  dateRange: {
    from: new Date(store.dateRange.from),
    to: new Date(store.dateRange.to),
  },
  q: store.q,
});
